<template>
	<div class="content-box" v-loading="loadings.main">
		<div class="row">
			<div class="col-md-12 mt-3">
				<form-operator
					:data-model-name="dataModelName"
					:rules="rules"
					:fields="editorFields"
					@submit="onSubmit"
					v-model="info"
				></form-operator>
			</div>
		</div>
	</div>
</template>

<script>
import FormOperator from "@/components/FormOperator.vue";

export default {
	data() {
		return {
			dataModelName: "Adminuser",
			info: {},
			editorFields: [
				{
					name: "name",
					col: 12
				},
				{
					name: "phone",
					col: 12
				}
			],
			rules: {
				name: [
					{
						required: true
					}
				],
				phone: [{ required: true, message: "请输入", trigger: "blur" }]
			},
			loadings: {
				main: false
			},
			hasGetData: false
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		refreshData() {
			this.loadings.main = true;
			this.$axios
				.post(`/admin/info/`)
				.then(json => {
					this.loadings.main = false;
					for (let k in json.data.info) {
						this.$set(this.info, k, json.data.info[k]);
					}
					this.hasGetData = true;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
		onSubmit(data) {
			this.loadings.main = true;

			this.$axios
				.post("/admin/do_edit_info/", data)
				.then(json => {
					this.$message({
						type: "success",
						message: "成功!"
					});
					this.loadings.main = false;
				})
				.catch(json => {
					this.loadings.main = false;
					if (this.err[json.data.field]) {
						this.err[json.data.field] = json.data.msg;
					}
					this.$message({
						message: json.data.msg,
						type: "error"
					});
				});
		}
	},
	watch: {},
	components: {
		FormOperator
	}
};
</script>
<style lang="scss" scoped>
</style>
